import redirectInterceptor from "@/interceptors/redirect_interceptor";
import tileZXYToLatLonBBox from "../../helper_functions/tile_to_bounding_box";
import coordinatesToTiles from "../../helper_functions/coordinates_to_tiles";

const localWeatherRoutingServerUrl = process.env.VUE_APP_LOCAL_WR_API_URL;

const getDefaultState = () => {
  return {
    selectedMeteoOption: 512,
    selectedDate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10),
    selectedTime: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(11, 19),//new Date().toLocaleTimeString(),
    renderingIsLoading: false,
    renderingError: false,
  };
};

const state = getDefaultState();

const getters = {
  getUTCTimestamp(state) {
    const dateTimeNotSelected = state.selectedDate === null && state.selectedTime;

    const dateTime = dateTimeNotSelected
      ? new Date()
      : new Date(`${state.selectedDate}T${state.selectedTime}`);

    const timestampInSeconds = Math.floor(dateTime.getTime() / 1000);

    return timestampInSeconds;
  }
};

const actions = {

  // eslint-disable-next-line no-empty-pattern
  removeCurrentLayer({ }, payload) {
    const mapReference = payload.map;
    const layerRegEx = /^weather-tile-layer-\d+$/;
    const sourceRegEx = /^weather-tile-source-\d+$/;

    const imageLayers = mapReference
      .getStyle()
      .layers.filter((layer) => layerRegEx.test(layer.id));
    imageLayers.map((layer) => {
      mapReference.removeLayer(layer.id);
    });

    const sourceLayers = mapReference.getStyle().sources;
    for (const key of Object.keys(sourceLayers)) {
      if (sourceRegEx.test(key)) {
        mapReference.removeSource(key);
      }
    }
  },

  // eslint-disable-next-line no-empty-pattern
  _displayImageLayer({ }, payload) {
    const mapReference = payload.map;
    const sourceId = payload.sourceId;
    const layerId = payload.layerId;
    const objectUrl = payload.objectUrl;
    const tileBounds = payload.tileBounds;

    mapReference.addSource(sourceId, {
      type: "image",
      //type:"raster",
      url: objectUrl,
      coordinates: tileBounds,
    });

    mapReference.addLayer(
      {
        id: layerId,
        type: "raster",
        source: sourceId,
        paint: {
          "raster-opacity": 0.6,
        },
      },
      // TODO: Make this dynamic based on the layer name
      "country-boundaries"
    );
  },

  // eslint-disable-next-line no-empty-pattern
  _setUpCurrentMapState({ }, payload) {
    const mapReference = payload.map;
    const neLongitude = mapReference.getBounds()._ne.lng;
    const neLatitude = mapReference.getBounds()._ne.lat;
    const swLongitude = mapReference.getBounds()._sw.lng;
    const swLatitude = mapReference.getBounds()._sw.lat;
    const currentZoom = Math.trunc(mapReference.getZoom()) + 1;

    const neTile = coordinatesToTiles(neLongitude, neLatitude, currentZoom);
    const swTile = coordinatesToTiles(swLongitude, swLatitude, currentZoom);

    const xMax = neTile.x;
    const yMin = neTile.y;

    const xMin = swTile.x;
    const yMax = swTile.y;

    return {
      xMax: xMax,
      yMin: yMin,
      xMin: xMin,
      yMax: yMax,
      zoom: currentZoom,
    };

  },

  async _fetchWeatherTiles({ rootState, getters, commit }, payload) {

    const accessToken = rootState.weatherRouting.weatherRoutingAccessToken;
    const xMax = payload.xMax;
    const yMin = payload.yMin;

    const xMin = payload.xMin;
    const yMax = payload.yMax;

    const zoom = payload.zoom;

    const meteo = payload.meteo;

    const utcTimeStamp = getters.getUTCTimestamp;

    const requests = [];
    const tileCoordinates = [];

    let repStarter = xMin;
    let repNum = xMax - xMin + 1;

    const xTileMax = Math.pow(2, zoom);

    if (xMin > xMax) {

      repStarter = xMin;
      repNum = xTileMax - xMin + xMax + 1;

    }
    else if (xMin === xMax) {
      repStarter = xMin;
      repNum = xTileMax;
    }

    let i = repStarter;
    //for (let i = xMin; i < xMax + 1; i++) {
    for (let r = 0; r < repNum; r++) {

      for (let j = yMin; j < yMax + 1; j++) {
        const request = redirectInterceptor.get(
          `${localWeatherRoutingServerUrl}/rdasTiles/${zoom}/${i}/${j}`,
          {
            responseType: "blob",
            headers: {
              "access-token": localStorage.getItem("quad_token"),
              "theyr-token": `${accessToken}`
            },
            params: {
              DataViewId: meteo,
              //resourceId: 27,
              timestamp: utcTimeStamp,
              //mode: 1
            }
          }
        );
        requests.push(request);
        tileCoordinates.push({ x: i, y: j });
      }
      i++;
      if (i === xTileMax)
        i = 0;
    }

    try {
      const responses = await Promise.all(requests);

      const weatherTilesUrls = [];
      const tilesBounds = [];

      for (let k = 0; k < responses.length; k++) {
        const response = responses[k];
        const { x, y } = tileCoordinates[k];

        if (response.status >= 200 && response.status < 400) {
          try {
            const imageObjectUrl = URL.createObjectURL(response.data);
            const tileBounds = tileZXYToLatLonBBox(zoom, x, y);
            weatherTilesUrls.push(imageObjectUrl);
            tilesBounds.push(tileBounds);
          } catch (e) {

            commit("SET_RENDERING_FAILURE", "Error in loading tiles");
          }
        } else {

          commit("SET_RENDERING_FAILURE", response.statusText);
          return {};
        }
      }

      return {
        "weatherTilesObjectUrls": weatherTilesUrls,
        "tilesBounds": tilesBounds
      };
    } catch (error) {

      commit("SET_RENDERING_FAILURE", error.message || "Error fetching weather tiles");
      return {};
    }
  },

  async loadTile({ dispatch, commit }, payload) {
    commit("SET_LOADING_STATE");

    const mapReference = payload.map;
    const sourceIdBase = payload.sourceIdBase;
    const layerIdBase = payload.layerIdBase;
    const meteo = payload.meteo;

    const currentMapState = await dispatch("_setUpCurrentMapState", { map: mapReference });
    const response = await dispatch("_fetchWeatherTiles", { ...currentMapState, "meteo": meteo });
    try {
      dispatch("removeCurrentLayer", {
        map: mapReference,
      });
    } catch (e) {

      commit("SET_RENDERING_FAILURE", "Error in removing existing tiles");
      return;
    }

    const weatherTilesObjectUrls = response.weatherTilesObjectUrls;
    const tilesBounds = response.tilesBounds;

    for (let i = 0; i < weatherTilesObjectUrls.length; i++) {
      try {
        const weatherTileObjectUrl = weatherTilesObjectUrls[i];
        const tileBounds = tilesBounds[i];

        dispatch("_displayImageLayer", {
          "map": mapReference,
          "sourceId": `${sourceIdBase}-${i}`,
          "layerId": `${layerIdBase}-${i}`,
          "objectUrl": weatherTileObjectUrl,
          "tileBounds": tileBounds
        });
      } catch (e) {

        commit("SET_RENDERING_FAILURE", "Error in displaying tiles");
        return;
      }
    }
    commit("SET_RENDERING_SUCCESS");
  },

};

const mutations = {
  SET_RENDERING_IS_LOADING: (state, data) => (state.renderingIsLoading = data),
  RESET_STATE: (state) => Object.assign(state, getDefaultState()),
  SET_SELECTED_DATE: (state, data) => (state.selectedDate = data),
  SET_SELECTED_TIME: (state, data) => (state.selectedTime = data),
  SET_LOADING_STATE(state) {
    state.renderingIsLoading = true;
    state.renderingError = null;
  },
  SET_RENDERING_SUCCESS(state) {
    state.renderingIsLoading = false;
    state.renderingError = null;
  },
  SET_RENDERING_FAILURE(state, data) {
    state.renderingIsLoading = false;
    state.renderingError = data;
  },
};

export const weatherRoutingTilesModule = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
